{
  "sidebar": {
    "hubs": "Hubs",
    "users": "Users",
    "admins": "Administrators",
    "signOut": "Sign Out"
  },
  "common": {
    "actions": "Actions",
    "page": "Page",
    "currentFile": "Current File",
    "newFile": "New File",
    "uploadNewFile": "Upload New File",
    "of": "of",
    "currency": "RSD",
    "hour": "hour",
    "locked": "Locked",
    "unlocked": "Unlocked",
    "on": "ON",
    "off": "OFF",
    "noData": "No Data",
    "performingAction": "Performing Action...",
    "success": "Success",
    "warning": "Warning",
    "error": "Error",
    "pleaseTryAgain": "Please try again.",
    "noTableData": "No data to display.",
    "changeLanguage": "CMS Language",
    "languageChanged": "Language successfully changed",
    "failedToChangeLanguage": "Failed to change language",
    "breadcrumbs": {
      "hubs": "Hubs",
      "users": "Users",
      "parkingSpots": "Parking Spots",
      "admins": "Administrators"
    },
    "enums": {
      "hubStatus": {
        "ONLINE": "Online",
        "OFFLINE": "Offline",
        "total": "Total"
      },
      "parkingSpotUsage": {
        "AVAILABLE": "Available",
        "OCCUPIED": "Occupied"
      },
      "parkingSpotUsageStatus": {
        "STARTED": "Started",
        "ENDED": "Ended"
      },
      "parkingSpotStatus": {
        "ONLINE": "Online",
        "OFFLINE": "Offline"
      },
      "userStatus": {
        "ACTIVE": "Active",
        "INACTIVE": "Inactive",
        "total": "Total"
      }
    },
    "errors": {
      "email": "Field must be a valid email address",
      "minlength": "Field must have at least {{requiredLength}} characters. Current length is {{actualLength}}",
      "required": "Field is required",
      "maxlength": "Field can have a maximum of {{requiredLength}} characters. Current length is {{actualLength}}",
      "pattern": "Field must match the pattern {{requiredPattern}}",
      "min": "Field must be minimum {{min}}",
      "max": "Field can be maximum {{max}}"
    }
  },
  "confirmations": {
    "delete": "Delete this item?"
  },
  "buttons": {
    "no": "Cancel",
    "yes": "Confirm"
  },
  "maps": {
    "latitude": "Latitude",
    "longitude": "Longitude",
    "price": "Price",
    "maxTime": "Max Time",
    "status": "Status"
  }
}
